import { ImagesData } from '@/interface/top-up-active';

// 奖品类型下拉选项
export const configKindOptions = [
  { label: '虚拟-免费', value: 1 },
  { label: '虚拟-收费', value: 2 },
  { label: '云币', value: 3 },
  { label: '周期卡', value: 4 },
];

/**
 * 正整数校验
 * @param _
 * @param value
 * @param callback
 */
const natureNumber = (_: any, value: number = 0, callback: Function) => {
  if (isNaN(value)) {
    callback(new Error('请输入数字'));
  } else if (value <= 0) {
    callback(new Error('请输入大于0的整数'));
  } else if (parseInt(value.toString() || '0') != parseFloat(value.toString() || '0')) {
    callback(new Error('请输入整数'));
  } else {
    callback();
  }
};

/**
 * 图片校验
 * @param value
 * @param callback
 */
const imageRule = (_: any, value: ImagesData, callback: Function) => {
  if (!value.imageUrl) {
    callback(new Error('请上传图片'));
  } else {
    callback();
  }
};

/**
 * 表单校验规则
 */
export const rules = {
  name: [
    { required: true, message: '请输入礼物名称', trigger: 'blur' },
    { min: 1, max: 8, message: '长度在 1 到 8 个字符', trigger: 'blur' },
  ],
  kind: [{ required: true, message: '请选择礼物类型', trigger: 'change' }],
  kind1: {
    cooling: [
      { required: true, message: '请输入冷却时长', trigger: 'blur' },
      { validator: natureNumber, trigger: ['change', 'blur'] },
    ],
    max: [
      { required: true, message: '请填入最多累积数量', trigger: 'blur' },
      { validator: natureNumber, trigger: ['change', 'blur'] },
    ],
  },
  kind2: {
    price: [
      { required: true, message: '请输入云朵数量', trigger: 'blur' },
      { validator: natureNumber, trigger: ['change', 'blur'] },
    ],
  },
  kind3: {
    coin: [
      { required: true, message: '请填入云币数量', trigger: 'blur' },
      { validator: natureNumber, trigger: ['change', 'blur'] },
    ],
    price: [
      { required: true, message: '请输入云朵数量', trigger: 'blur' },
      { validator: natureNumber, trigger: ['change', 'blur'] },
    ],
  },
  kind4: {
    duration: [
      { required: true, message: '请填入周期卡分钟数', trigger: 'blur' },
      // { validator: natureNumber, trigger: 'change' },
    ],
    expire: [
      { required: true, message: '请填入周期卡有效天数', trigger: 'blur' },
      { validator: natureNumber, trigger: ['change', 'blur'] },
    ],
    price: [
      { required: true, message: '请输入云朵数量', trigger: 'blur' },
      { validator: natureNumber, trigger: ['change', 'blur'] },
    ],
  },

  hots: [
    { required: true, message: '请填入热度值', trigger: 'blur' },
    { validator: natureNumber, trigger: ['change', 'blur'] },
  ],
};
